/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import ConferencesIcon from 'icons/ConferencesIcon';

const messages = defineMessages({
  title: {id: 'navigation.conferences'},
});

const ConferencesItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={ConferencesIcon}
    route="midas/staff-member/conferences"
    title={messages.title}
  />
);

export default ConferencesItem;
